/**
 * PlaceholderPage — Phase A/B 라우트 셸용 (Issue #447)
 *
 * Phase B에서 vite alias `@app/*` 검증을 위해 `@app/components/SectionedSummary`를
 * mock summary로 렌더링합니다. 페이지 통째 마이그레이션(LoginPage/FeedPage 등)은
 * service/i18n/auth chain 어댑터화가 선행되어야 하므로 Phase F+에서 처리합니다.
 *
 * 본 컴포넌트는 다음을 검증합니다:
 * - vite resolve.alias `@app` → `../app/src` 동작
 * - vite resolve.extensions `.web.tsx` 우선순위
 * - `@tldr/utils` workspace 패키지 transitive 호환 (SectionedSummary가 사용)
 */

import { Page, Navbar, Block, BlockTitle } from 'framework7-react';
import SectionedSummary from '@app/components/SectionedSummary';

const MOCK_SUMMARY_LONG = `## Phase B 검증 섹션

이 섹션은 vite alias \`@app\`로 \`app/src/components/SectionedSummary\`를 web 빌드에서 import하여 렌더링합니다.

## 다음 Phase

- Phase C+: og-meta Edge Function, MCP 서버 분리, Vercel 정적 SPA 배포
- Phase F+: AuthContext / i18n / service layer 어댑터화 후 페이지 통째 이식
`;

interface PlaceholderPageProps {
  label?: string;
}

export default function PlaceholderPage({ label = 'Placeholder' }: PlaceholderPageProps) {
  return (
    <Page name="placeholder">
      <Navbar title="DISTILL" backLink="Back" />
      <Block strong>
        <BlockTitle>{label}</BlockTitle>
        <p>이 라우트는 Phase A/B 셸 단계입니다. 실제 페이지 컴포넌트는 후속 Phase에서 마운트됩니다.</p>
      </Block>
      <Block>
        <BlockTitle>vite alias <code>@app/*</code> 검증</BlockTitle>
        <SectionedSummary summaryLong={MOCK_SUMMARY_LONG} />
      </Block>
    </Page>
  );
}
